__turbopack_context__.v({
  "content": "E_5WdG_content",
  "outlet": "E_5WdG_outlet",
  "page": "E_5WdG_page",
});
